export default {
  items: [
    {
      name: 'Dashboards',
      url: '/dashboards',
      icon: 'icon-puzzle'
    },
    {
      name: 'Clients',
      url: '/clients',
      icon: 'icon-people'
    },
    {
      name: 'Client Groups',
      url: '/client_groups',
      icon: 'icon-people'
    },
    {
      name: 'Metrics',
      url: '/metrics',
      icon: 'icon-calculator'
    },
    {
      name: 'Reports',
      url: '/reports',
      icon: 'icon-calendar'
    },
    {
      name: 'Import data',
      url: '/import_data',
      icon: 'icon-cloud-download'
    }

  ]
}
